export default "__VITE_ASSET__DI4YAAL2__"